import * as React from 'react';
import cn from 'classnames';

import { WidgetTexts } from 'widget/consts/texts';
import Typography, {
  TypographyColor,
  TypographySize,
  TypographyWeight
} from 'widget/shared/ui/Typography';

import styles from './DropZone.module.scss';
import { useDropZone } from './useDropZone';

type DropZoneProps = React.PropsWithChildren<{
  onDrop: (_files: File[]) => void;
  className?: string;
}>;

const DropZone: React.FC<DropZoneProps> = ({ onDrop, className, children }) => {
  const {
    isDragActive,
    isOver,
    dragEnterHandler,
    dragLeaveHandler,
    dragOverHandler,
    dropHandler
  } = useDropZone(onDrop);
  return (
    <div className={cn(styles['root'], className)}>
      {children}
      {isDragActive && (
        <div
          className={cn(styles['overlay'], isOver && styles['overlay_active'])}
          onDragEnter={dragEnterHandler}
          onDragLeave={dragLeaveHandler}
          onDragOver={dragOverHandler}
          onDrop={dropHandler}
        >
          <Typography
            color={TypographyColor.background}
            size={TypographySize.l}
            weight={TypographyWeight.semiBold}
            className={styles['overlay__text']}
          >
            {WidgetTexts.messageForm.dropZone.placeholder}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default React.memo(DropZone);
